const STORE = "tropicalcode";
const VARIANT_ID = "6842fe56-553a-492c-8624-ad9b2caf333c";
const LEMON_URL = `https://${STORE}.lemonsqueezy.com`;
export const LEMON_CHECKOUT_URL = `${LEMON_URL}/buy/${VARIANT_ID}`;
export const LEMON_CUSTOMER_PORTAL_URL = `${LEMON_URL}/billing`;
